import React from 'react';
import SecondaryBanner from '@ajat/design-system/ContentBlocks/SecondaryBanner';
import { ComponentPage, DemoCard } from '../../shared';
import { HERO_IMAGE } from './contentDemoData';

const TRUSTPILOT = {
  businessUnitId: '46905da900006400050004f8',
  locale: 'da-DK',
  reviewUrl: 'https://dk.trustpilot.com/review/cls.dk',
};

export const meta = {
  component: SecondaryBanner,
  componentName: 'SecondaryBanner',
  title: 'Secondary Banner',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/SecondaryBanner',
  figmaNode: '8746:73145',
  description:
    'The photo banner that opens a school shop: a glass tag (the shop / category), an editorial "School / Class" title and a Trustpilot widget. Desktop is a 1360×480 box inside the layout gutters; mobile is full-bleed at 560px. Without a tag the banner does not render; without a title the tag copy becomes the title and the glass tag is hidden.',
  props: [
    ['tag', 'node', '—', 'Glass tag — the shop / category, e.g. "Studieturstrøjer" (typo-h3). Empty → the banner is not rendered'],
    ['title', 'string', "''", 'Title (typo-h1-editorial); " / " segments get a gray-2 separator — "School / Class". Empty → the tag copy is shown as the title, the tag is hidden'],
    ['backgroundImage', 'string', 'Studietur desktop photo', 'Desktop photo'],
    ['backgroundImageMobile', 'string', '—', 'Mobile photo; defaults to the Studietur mobile photo, or to backgroundImage when that is custom'],
    ['trustpilot', 'object', 'CLS-DK defaults', '{ businessUnitId, locale, reviewUrl } — pass null to hide the widget'],
  ],
  usage: [
    {
      title: 'Top of a school shop',
      code: `import SecondaryBanner from '@ajat/design-system/ContentBlocks/SecondaryBanner';

<SecondaryBanner
  tag="Studieturstrøjer"
  title={\`\${school.name} / \${className}\`}
  backgroundImage={bannerDesktop}
  backgroundImageMobile={bannerMobile}
/>`,
    },
  ],
};

export default function SecondaryBannerPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Default photo" hint="CLS-DK Studietur" flush>
        <SecondaryBanner tag="Studieturstrøjer" title="Nørre Gymnasium / 3.A" trustpilot={TRUSTPILOT} />
      </DemoCard>

      <DemoCard title="Custom photo" hint="one image for both widths" flush>
        <SecondaryBanner tag="Skolmerch" title="Katedralskolan / 3C" backgroundImage={HERO_IMAGE} trustpilot={TRUSTPILOT} />
      </DemoCard>

      <DemoCard title="No school chosen" hint="no title → tag copy becomes the title" flush>
        <SecondaryBanner tag="Studieturstrøjer" trustpilot={TRUSTPILOT} />
      </DemoCard>

      <DemoCard title="Without Trustpilot" flush>
        <SecondaryBanner tag="Vogntrøjer" title="Roskilde Katedralskole / 2.D" trustpilot={null} />
      </DemoCard>
    </ComponentPage>
  );
}
